import React, { createContext, useCallback, useState } from 'react';

import { Nullable } from '@tager/web-core';

export type ContextType = {
  price: Nullable<number>;
  discountPrice: Nullable<number>;
  optionData: {
    optionName: Nullable<string>;
    optionValue: Nullable<string>;
  };
  priceHandler?: (
    price: Nullable<number> | undefined,
    discount: Nullable<number> | undefined
  ) => void;
  optionHandler?: (name: string, value: string) => void;
};

const initContext: ContextType = {
  price: null,
  discountPrice: null,
  optionData: {
    optionName: null,
    optionValue: null,
  },
};

export const productContext = createContext(initContext);

type ProductContextProviderType = {
  children: React.ReactNode;
};

export function ProductContextProvider({
  children,
}: ProductContextProviderType) {
  const [price, setPrice] = useState(initContext.price);
  const [discountPrice, setDiscountPrice] = useState(initContext.discountPrice);
  const [optionData, setOptionData] = useState(initContext.optionData);

  const priceHandler = (
    price: Nullable<number> | undefined,
    discount: Nullable<number> | undefined
  ) => {
    if (price && discount && discount !== price) {
      setPrice(price);
      setDiscountPrice(discount);
      return;
    }
    if (price) {
      setPrice(price);
    }
  };

  const optionHandler = useCallback((name: string, value: string) => {
    setOptionData({
      optionName: name,
      optionValue: value,
    });
  }, []);

  const values = {
    price,
    discountPrice,
    priceHandler,
    optionHandler,
    optionData,
  };

  return (
    <productContext.Provider value={values}>{children}</productContext.Provider>
  );
}
